import React from 'react';
import { Provider } from 'react-redux';
import store, { persistor } from './redux/store';
import { BrowserRouter as Router } from 'react-router-dom';
import Views from './views';
import { PersistGate } from 'redux-persist/integration/react'
import { Route, Switch } from 'react-router-dom';
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from './configs/AppConfig';

const THEME_PREFERENCE_KEY = 'app-theme-mode';

const getDefaultTheme = () => {
  try {
    const storedTheme = localStorage.getItem(THEME_PREFERENCE_KEY);
    return storedTheme === 'light' || storedTheme === 'dark'
      ? storedTheme
      : THEME_CONFIG.currentTheme;
  } catch (error) {
    return THEME_CONFIG.currentTheme;
  }
};

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

  function App() {
    return (
      <div className="App">
      <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeSwitcherProvider themeMap={themes} defaultTheme={getDefaultTheme()} insertionPoint="styles-insertion-point">
          <Router>
            <Switch>
              <Route path="/" component={Views}/>
            </Switch>
          </Router>
        </ThemeSwitcherProvider>
        </PersistGate>
      </Provider>
    </div>
  );
}

export default  App 
 